import { template } from './template/template';

export const environment = {
  production: true,
  debug: false,
  useGo: true,
  lite: true,
  fast: true,
  isMobile: false,
  customLogin: false,
  isLocal: false,
  template: template,
  apiUrl: 'https://api.knappmann.stage.valueminer.eu',
  messagingUrl: 'https://knappmann.stage.valueminer.eu/messaging',
  messagingSocketNamespace: 'https://knappmann.stage.valueminer.eu',
  messagingSocketPath: '/socket.io',
  exportUrl: 'https://export.knappmann.stage.valueminer.eu',
  oauthUrl: 'https://oauth.knappmann.stage.valueminer.eu',
  imageUrl: 'https://oauth.knappmann.stage.valueminer.eu/profile/?id=',
  fileupload: 'https://oauth.knappmann.stage.valueminer.eu',
  go: 'https://apigo.knappmann.stage.valueminer.eu',
  goPrefix: {},
  goSuffix: {},
  app: '',
  s3: 'valueminer.local',
  aws: {
    access_key_id: 'AKIAVQ3RHJYALBWTHAN4',
    access_key_secret: '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',
    s3_bucket: 'valueminer.local',
    s3_region: 'eu-central-1',
  },
  auth: {
    authurl: 'https://oauth.knappmann.stage.valueminer.eu/oauth/authorize/',
    tokenurl: 'https://oauth.knappmann.stage.valueminer.eu/oauth/token/',
    logouturl: 'https://oauth.knappmann.stage.valueminer.eu/wp-login.php?action=logout',
    authorization: {},
    clientID: 'valueminer',
    mobileClientId: 'mobile',
    redirectURL: 'https://knappmann.stage.valueminer.eu/',
    scopes: ['api', 'users']
  },
  socket: {
    url: 'https://apigo.knappmann.stage.valueminer.eu',
    path: '/socket.io/'
  },
  design: {
    key: '',
    logo: './assets/svg/logo.green.svg',
    title: 'ValueMiner',
    titleIsImage: false,
    subtitle: '',
    welcomeText: ''
  },
  roleSelection: {
    norole: undefined
  },
  mobileDesign: {}
};
